import {toast} from 'react-toastify'
import {CheckIcon, ErrorCloseIcon} from '../icons'
import classNames from 'classnames'

const ZERO = 0
const OBJECT_TYPE = 'object'

const showError = (errorMessage) => {
    toast.error(errorMessage || 'Error')
}

const setFormElementError = (fields, message, ...setFieldError) => {
    let setErrorFnIsExecuted = false
    if (!fields) {
        showError(message)
        return
    }

    const fieldsArr = Object.keys(fields)
    if (!fieldsArr?.length) {
        showError(message)
        return
    }

    if (fieldsArr.includes('common')) {
        showError(fields.common?.[0] || message)
        return
    }

    setFieldError.forEach((setErrorFn) => {
        if (typeof setErrorFn === 'function') {
            fieldsArr.forEach((item) => {
                if (typeof fields[item]?.[0] === 'string' && /<\/?[a-z][\s\S]*>/i.test(fields[item]?.[0])) { setErrorFnIsExecuted = true }

                setErrorFn(item, fields[item]?.join('<br>'))
            })
        }
    })

    if (setErrorFnIsExecuted) {
        return
    }

    fieldsArr.forEach((item, index) => {
        index === 0 ? showError(fields[item]?.[0]) : null
    })
}

const getValidationToolTip = (checkIsValid, values, name, formErrors, touched, title, isDarkMode) => {
    return (!checkIsValid(values, name) && formErrors?.[name].length > 0 && touched[name]) && (
        <div className={classNames('error-box', {
            dark: isDarkMode
        })}>
            <div className="box-title">{title}</div>
            {formErrors[name].map((item, index) =>
                <div key={index} className="error-item">
                    {
                        item.status ?
                            <ErrorCloseIcon width='16' height='16'/> :
                            <CheckIcon width='16' height='16'/>
                    }
                    <span className="error-message">{item.message}</span>
                </div>
            )
            }
        </div>
    )
}

const getReminderOptions = (start, end) => {
    const days = []

    for (let i = start; i <= end; i++) {
        days.push({
            value: i,
            label: `${i} ${i > 1 ? 'days' : 'day'} in advance`
        })
    }

    return days
}

const flattenErrors = (errors, parentKey = '', result = {}) => {
    if (Array.isArray(errors) && parentKey) {
        result[parentKey] = errors
        return result
    }

    Object.entries(errors).forEach(([key, value]) => {
        const newKey = parentKey ? `${parentKey}.${key}` : key

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const itemKey = `${newKey}[${index}]`

                if (typeof item === OBJECT_TYPE && item !== null) {
                    const hasNestedArrays = Array.isArray(item) && item.some(i => Array.isArray(i))
                    const hasObjectKeys = Object.keys(item).length > 0
                    if (hasNestedArrays || hasObjectKeys) {
                        flattenErrors(item, itemKey, result)
                        return
                    }
                }

                result[newKey] = value
            })
            return
        }

        if (typeof value === OBJECT_TYPE && value !== null) {
            flattenErrors(value, newKey, result)
            return
        }

        result[newKey] = value
    })

    return result
}

const handleFormChanges = (e, name, setFieldValue, initialFormValues, isCheckbox = false) => {
    if (Array.isArray(e) && e.every(item => item?.value && item?.label)) {
        setFieldValue(name, e)
        return initialFormValues[name] === e
    }
    if (e?.isKeyword) {
        setFieldValue(name, e)
        return initialFormValues[name] === e
    }
    if ((e?.value || e?.value === ZERO) && e?.label) {
        setFieldValue(name, e)
        return initialFormValues[name] === e
    }
    if (isCheckbox) {
        setFieldValue(name, e)
        return initialFormValues[name] === e
    }
    const target = e?.target || e
    try {
        setFieldValue(name, target.value)
    } catch (e) {
        setFieldValue(name, target)
    }
    try {
        return initialFormValues[name] === target?.value?.trim()
    } catch (e) {
        return initialFormValues[name] === target
    }
}

const extractOnlyValues = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(value => extractOnlyValues(value))
    }

    if (typeof obj === 'object' && obj !== null) {
        if ('value' in obj) {
            return ({value: obj.value, form_type: obj?.form_type, type: obj?.type})
        }
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, {value: value.value, form_type: value?.form_type, type: value?.type}])
        )
    }

    return obj
}

const hasIntersection = (array1, array2) => array1.some(element1 =>  array2.includes(element1))

const greaterThan = (value, definedValue) => value > definedValue
const lessThan = (value, definedValue) => value < definedValue
const greaterThanOrEqual = (value, definedValue) => value >= definedValue
const lessThanOrEqual = (value, definedValue) => value <= definedValue
const greaterThanOrEqualToZero = (value) => greaterThanOrEqual(value, ZERO)

export {greaterThan,
    lessThan,
    greaterThanOrEqual,
    lessThanOrEqual,
    greaterThanOrEqualToZero,
    hasIntersection,
    handleFormChanges,
    flattenErrors,
    extractOnlyValues}

export default {
    setFormElementError,
    getValidationToolTip,
    getReminderOptions
}
